export default {
    empty: true,
};




// WEBPACK FOOTER //
// ./themes/fq/view/foreground-view.js